interface StatusBadgeProps {
  status: 'Paid in full' | 'Current' | 'Overdue' | 'Archived' | 'Pending';
  size?: 'sm' | 'md';
}
export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  let dotColor = '';
  let textColor = '';
  switch (status) {
    case 'Paid in full':
      dotColor = 'bg-aquamarine';
      textColor = 'text-jungle';
      break;
    case 'Current':
      dotColor = 'bg-primary';
      textColor = 'text-primary';
      break;
    case 'Overdue':
      dotColor = 'bg-strawberry';
      textColor = 'text-strawberry';
      break;
    case 'Archived':
      dotColor = 'bg-text-tertiary';
      textColor = 'text-text-tertiary';
      break;
    case 'Pending':
      dotColor = 'bg-coral';
      textColor = 'text-coral';
      break;
    default:
      dotColor = 'bg-text-tertiary';
      textColor = 'text-text-tertiary';
  }
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';
  const dotSize = size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2';
  return (
    <div className="flex items-center gap-2">
      <span
        className={`${dotSize} rounded-full ${dotColor}`}
        aria-hidden="true" />
      
      <span className={`font-body ${textSize} ${textColor} font-medium`}>
        {status}
      </span>
    </div>);

}
